module.exports = __webpack_public_path__ + "o.no2.61ba8187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/o.no2.jpg
// module id = csui
// module chunks = 0